import { apiRequest } from '../../apiCall'

export const getDocument = (params) => apiRequest('CustomerDocuments.GetCustomerDocuments', {}, `?customerDocumentTypeField=${params}`);
export const saveDocument = (params) => apiRequest('CustomerDocuments.Save', params, `?customerDocumentTypeField=2`);
export const deleteDocument = (params) => apiRequest('CustomerDocuments.DeleteById', params.Id)
export const getNationalCardCustomerDocumentStatusRequest = () => apiRequest('CustomerDocuments.getNationalCardCustomerDocumentStatus', {},);
export const deleteDocumentUser = (params) => apiRequest('CustomerDocuments.Delete', params)


